<template lang="pug">
  div
    el-card
      label 用户：
      el-select(v-model="user" @change="changeUser()")
        el-option(v-for="user in users"
          :key="user._id"
          :label="user.account"
          :value="user.account")
      span &nbsp;&nbsp;
      label 关键指标：
      el-select(v-model="zb" @change="changeZb()")
        el-option(v-for="zb in zbs"
          :key="zb"
          :label="zb"
          :value="zb")
    el-card
      div.tm-row(style="width:50%;")
        b 业绩：{{ perform.num }}
        el-progress(:percentage="perform.percent" :text-inside="true" :stroke-width="18" :status="perform.status")
      div.tm-row(style="")
        b 今天：
        div(style="padding-left:10px;")
          div(v-for="(v,k) in goalHead") {{ k }}：{{ todayData[v] }}
      div.tm-row
        b 本周每日：
        el-table(:data="weekData" border :row-class-name="tableRowClassName")
          el-table-column(v-for="h,k in goalHead" :prop="h" :label="k" :key="h")
      div.tm-row
        b 本周汇总：
        el-table(:data="kpiData" border :row-class-name="tableRowClassName")
          el-table-column(v-for="h,k in zbs" :prop="h" :label="h" :key="h")

</template>
<style>
.tm-row {
  margin-bottom: 10px;
  font-size: 14px;
}
.tm-row .el-table {
  width: 100%;
  margin-top: 5px;
}
.el-table .info-row {
  background: #ff4949;
}
.el-table .info-row:hover {
  background: #ff4949;
}
</style>
<script>
// Generated by CoffeeScript 2.3.0
let dateFormat, m

dateFormat = require('dateformat')

export default (m = {
  data: function() {
    return {
      user: '',
      users: [],
      nowUser: {},
      zb: '',
      zbs: [],
      goalHead: {
        日期: 'goal_date',
        关键指标: 'goal',
        目标: 'goal_num',
        完成: 'actual',
        理由: 'reason',
      },
      perform: {
        percent: 0,
        status: '',
        num: '0/0',
      },
      todayData: {},
      weekData: [],
      kpiData: [],
    }
  },
  methods: {
    getCurrentWeek: function() {
      let currentDate, millisecond, minusDay, monday, month, startStop, sunday, week
      startStop = new Array()
      currentDate = new Date(new Date(new Date().toLocaleDateString()).getTime())
      week = currentDate.getDay()
      month = currentDate.getDate()
      millisecond = 1000 * 60 * 60 * 24
      if (week === 0) {
        minusDay = 6
      } else {
        minusDay = week - 1
      }
      monday = new Date(currentDate.getTime() - minusDay * millisecond)
      sunday = new Date(monday.getTime() + 7 * millisecond - 1)
      startStop.push(monday)
      startStop.push(sunday)
      return startStop
    },
    tableRowClassName: function(row, index) {
      if (row.actual < row.goal_num) {
        return 'info-row'
      }
      return ''
    },
    changeUser: function() {
      let now_user
      now_user = this.users.filter(u => u.account === this.user)
      this.nowUser = now_user[0]
      this.zb = this.nowUser.goal || '电话'
      return this.getData()
    },
    changeZb: function() {
      return app
        .service('users')
        .patch(this.nowUser._id, {
          goal: this.zb,
        })
        .then(res => {
          this.nowUser.goal = this.zb
          if (this.user === app.user.account) {
            app.user.goal = this.zb
          }
          return (this.users = this.users.map(u => {
            if (u.account === this.user) {
              u.goal = this.zb
            }
            return u
          }))
        })
    },
    getPerform: function() {
      let pnum1, pnum2, ppercent
      pnum1 = this.nowUser['业绩目标'] || 0
      pnum2 = this.nowUser['业绩完成'] || 0
      if (pnum1 > 0 && pnum2 > 0) {
        this.perform.num = `${pnum2}/${pnum1}`
        ppercent = Math.round((parseInt(pnum2) / parseInt(pnum1)) * 100)
        this.perform.percent = ppercent
        if (ppercent < 60) {
          return (this.perform.status = 'exception')
        } else if (ppercent >= 100) {
          return (this.perform.status = 'success')
        }
      }
    },
    getToday: function() {
      let today
      today = dateFormat(new Date(), 'yyyy-mm-dd')
      return app.api
        .find({
          tableName: 'goals',
          query: {
            name: this.user,
            goal_date: today,
          },
        })
        .then(res => {
          if (res.length > 0) {
            return (this.todayData = res[0])
          } else {
            return (this.todayData = {})
          }
        })
    },
    getWeek: function() {
      let monday, sunday, week
      week = this.getCurrentWeek()
      monday = dateFormat(week[0], 'yyyy-mm-dd')
      sunday = dateFormat(week[1], 'yyyy-mm-dd')
      return app.api
        .find({
          tableName: 'goals',
          query: {
            name: this.user,
            goal_date: {
              $gte: monday,
              $lte: sunday,
            },
          },
        })
        .then(res => (this.weekData = res))
    },
    getKpi: function() {
      let monday, sunday, week
      week = this.getCurrentWeek()
      monday = Date.parse(week[0]) / 1000
      sunday = Date.parse(week[1]) / 1000
      return app.api
        .find({
          tableName: 'kpis',
          query: {
            姓名: this.user,
            date: {
              $gte: monday,
              $lt: sunday,
            },
          },
        })
        .then(tmp => {
          let d, day, kpis, kpis_obj, month, year
          if (this.nowUser['类型'] === '前端') {
            this.zbs = ['电话', '会面', '线人', '变动', 'BD-Leads', 'Mapping', '薪酬', 'LIST']
          } else {
            this.zbs = ['电话', '推荐', '面试', '变动', 'offer', '到岗', 'BD-Leads', 'LIST']
          }
          if (tmp.length > 0) {
            d = new Date()
            year = dateFormat(d, 'yyyy')
            month = dateFormat(d, 'mm')
            day = dateFormat(d, 'dd')
            week = this.getCurrentWeek()
            kpis_obj = {
              电话: 0,
              推荐: 0,
              面试: 0,
              offer: 0,
              到岗: 0,
              LIST: 0,
              变动: 0,
              会面: parseInt(this.nowUser['会面完成'] || 0),
              线人: parseInt(this.nowUser['线人完成'] || 0),
              'BD-Leads': 0,
              Mapping: parseInt(this.nowUser['Mapping完成'] || 0),
              薪酬: parseInt(this.nowUser['薪酬完成'] || 0),
            }
            kpis = []
            tmp.forEach(item => {
              let type
              type = item.type
              if (kpis_obj[type]) {
                return kpis_obj[type]++
              } else {
                return (kpis_obj[type] = 1)
              }
            })
            kpis.push(kpis_obj)
            kpis = kpis.map(kpi => {
              let biao, k, v
              for (k in kpi) {
                v = kpi[k]
                biao = this.nowUser[`${k}`] || 0
                if (k === 'offer' || k === '到岗' || k === 'LIST') {
                  kpi[k] = `${v}/${Math.ceil(biao / 4)}`
                } else if (k === '电话') {
                  kpi[k] = `${v}/${biao * 5}`
                } else {
                  kpi[k] = `${v}/${biao}`
                }
              }
              return kpi
            })
            return (this.kpiData = kpis)
          } else {
            return (this.kpiData = [])
          }
        })
    },
    getData: function() {
      this.getToday()
      this.getWeek()
      this.getKpi()
      return this.getPerform()
    },
  },
  created: function() {
    let account, member, param, ref, ref1, ref2
    this.user = app.user.account
    this.nowUser = app.user
    this.zb = app.user.goal || '电话'
    param = {
      tableName: 'users',
    }
    if (!app.user.角色 || !app.user.角色.includes('管理员')) {
      if (app.user.角色 && app.user.角色.includes('团队长')) {
        member = (ref2 = app.user) != null ? ref2['队员'] : void 0
      }
      if (member) {
        this.member = member.split(';')
      } else {
        this.member = []
      }
      account = [app.user.account].concat(this.member)
      param.query = {
        account: {
          $in: account,
        },
      }
    }
    return app.api.find(param).then(res => {
      this.users = res
      return this.getData()
    })
  },
})
</script>
